import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { TitleService } from '../services/title.service';

@Injectable({ providedIn: 'root' })
export class TitleGuard implements CanActivateChild {
  public canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (childRoute.routeConfig.title) {
      TitleService.title$.next(childRoute.routeConfig.title);
    }
    return true;
  }


}
